import { createService } from '../../api';
import { z } from 'zod';

export default createService({
  sendVersion: {
    method: 'PATCH',
    url: '/deviceInfo',
    responseSchema: z.object({}).optional(),
  },
});
